// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__tS0LL","entering":"PageWrapper_entering__RtpAL","entered":"PageWrapper_entered__4Zvgm","exiting":"PageWrapper_exiting__B1qC8"};